import angular from 'angular';
import _ from 'lodash';

angular
    .module('lad-mock')

    .controller('LadMockCtrl', [
        '$scope',
        '$filter',
        'LadMockService',
        'BatchService',
        function ($scope, $filter, LadMockService, BatchService) {
            var vm = this;

            vm.ladEmpty = ladEmpty;

            $scope.includes = {
                formMessages: require('../../common/form-messages.html'),
            };

            var emptyCriteria = {
                fileName: null,
                technique: {
                    batchDate: null,
                    receptionDate: null,
                    deliveryDate: null,
                },
                header: {
                    docType: null,
                    currency: null,
                },
                footer: {},
                indexSup: [],
            };

            vm.criteria = angular.copy(emptyCriteria);

            vm.ladDtos = LadMockService.findFiles();
            vm.showListFiles = true;
            vm.indexSupSize = 2;

            vm.backToFileList = backToFileList;
            vm.refreshFileList = refreshFileList;
            vm.fileClick = fileClick;
            vm.generateIndexFile = generateIndexFile;

            function indexSup(key, value) {
                this.key = key;
                this.value = value;
            }

            vm.addIndex = function () {
                vm.criteria.indexSup.push(new indexSup('', ''));
            };

            vm.removeIndex = function (index) {
                vm.criteria.indexSup.splice(index, 1);
            };

            // Retour à la liste des fichiers disponibles
            function backToFileList() {
                vm.showListFiles = true;

                // TODO Faire le ménage dans l'objet criteria ?

                refreshFileList();
            }

            // Rafraichit la liste des fichiers disponibles
            function refreshFileList() {
                vm.ladDtos = LadMockService.findFiles();
            }

            // Initialise le formulaire de saisie
            function initCriteria() {
                var criteria = angular.copy(emptyCriteria);
                criteria.header.docType = 'I';
                criteria.header.currency = 'EUR';

                var now = new Date();
                var oneHourAgo = new Date();
                oneHourAgo.setHours(oneHourAgo.getHours() - 1);
                criteria.technique.receptionDate = oneHourAgo.toISOString().substring(0, 19).replace(/-|:|T/g, '');
                criteria.technique.deliveryDate = now.toISOString().substring(0, 19).replace(/-|:|T/g, '');
                criteria.technique.media = 'E';
                vm.criteria = criteria;
            }

            function fileClick(ladDto) {
                vm.ladDtoSelected = ladDto;
                vm.showListFiles = false;

                initCriteria();
                var res = ladDto.fileName.split('-');
                vm.criteria.technique.batchDate = res[4];
                vm.criteria.technique.principalId = ladDto.fileName.substring(15, 20);
                vm.criteria.technique.batchName = ladDto.batchname;
                vm.criteria.technique.endoId = ladDto.batchname;
                vm.criteria.technique.validationDate = $filter('date')(new Date(), 'yyyyMMdd');
                vm.criteria.technique.documentPageCount = 1;
                vm.criteria.technique.language = 'FRA';
                LadMockService.getPdfFileSize(ladDto.fileName).then(function (result) {
                    vm.criteria.technique.size = result.data;
                });
                getPdfUrl(ladDto.batchname);
            }

            function generateIndexFile() {
                vm.criteria.fileName = vm.ladDtoSelected.fileName;
                LadMockService.generateIndexFile(vm.criteria);

                backToFileList();
            }

            function getPdfUrl(batchname) {
                // Récupération de l'identifiant du batch
                var batchIdStart = batchname.lastIndexOf('-') + 1;
                var batchIdEnd = batchname.length;
                var batchId = batchname.substring(batchIdStart, batchIdEnd);

                // Récupération de l'identifiant du PDF
                BatchService.get({ batchId: batchId }, function (batch) {
                    $scope.pdfUrl = '/kiss-boweb/proxy-epdf/api/v1/file/' + batch.pdfFileId;
                });
            }

            vm.testPattern = function testPattern(value, pattern) {
                var regex = new RegExp(pattern);
                return regex.test(value);
            };

            /**
             * Nous dit si la liste des fichiers mock est vide.
             */
            function ladEmpty() {
                return _.isEmpty(vm.ladDtos);
            }
        },
    ]);
